import React from 'react'

const AutomationOptionsVoiceCommand = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="53" viewBox="0 0 40 53" fill="none" className={className}>
    <path
      d="M0 1.5C5.26 1.5 10.83 1.75 15.12 5.19C15.6349 5.60137 16.1133 6.05639 16.55 6.55C18.5513 8.88839 19.6195 11.8829 19.55 14.96L19.81 20.77L23.81 28.46L20.17 30.1L19.99 33.15L14.28 34.51L19.12 37.25C19.12 37.25 17.89 43.34 15.46 44.4C13.03 45.46 11.07 45.35 3.97998 45.24"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M26.1808 32.58C27.0439 34.0761 27.278 35.8536 26.8318 37.5223C26.3856 39.1909 25.2955 40.6143 23.8008 41.48"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M36.6203 26.5601C39.0803 30.825 39.746 35.8923 38.4708 40.6479C37.1957 45.4035 34.0841 49.458 29.8203 51.9201"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M31.5701 29.47C33.2588 32.3955 33.7166 35.8719 32.8427 39.1348C31.9689 42.3977 29.8349 45.18 26.9102 46.87"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsVoiceCommand
